// ui/pages/CapacitacionDetallePage.jsx
// PDF: el backend genera el PDF oficial; aquí solo se guarda el Blob (loading en el botón, Swal si falla).
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import BlockUi from 'react-block-ui';
import BackButton from '../../../../../components/link/back-button.jsx';
import DetalleEncabezado from '../../../shared/ui/DetalleEncabezado.jsx';
import ImagenesDetalleSection from '../../../shared/ui/ImagenesDetalleSection.jsx';
import { showError } from '../../../shared/ui/feedback';
import { useCapacitacionDetalle } from '../../application/useCapacitacionDetalle';
import CapacitacionDetalle from '../components/CapacitacionDetalle.jsx';
import { guardarArchivo } from '../../../shared/ui/guardarArchivo';
import { CAPACITACIONES_PATH } from '../../../constants';

const listPath = `${CAPACITACIONES_PATH}/list`;

const CapacitacionDetallePage = () => {
  const { uuid } = useParams();
  const history = useHistory();
  const detalle = useCapacitacionDetalle({ uuid });
  const { data, fotos, status, error, descargarPdf, descargandoPdf } = detalle;
  const handleDescargarPdf = async () => {
    try {
      const archivo = await descargarPdf();
      if (archivo) guardarArchivo(archivo.blob, archivo.nombre);
    } catch (e) {
      await showError(e);
    }
  };

  React.useEffect(() => {
    if (status === 'error') showError(error);
  }, [status, error]);

  const editPath = data ? `${CAPACITACIONES_PATH}/edit/${data.uuid}` : listPath;

  return (
    <BlockUi tag="div" blocking={status === 'loading' && !data} renderChildren={true}>
      <div>
        <div className="mb-3">
          <BackButton label="Volver" goBackDefault={listPath} />
        </div>
        {data && (
          <>
            <DetalleEncabezado
              titulo={data.nombre_capacitacion}
              migas="Asistencia Técnica · Capacitaciones · Detalle"
              editPath={editPath}
              onDescargarPdf={handleDescargarPdf}
              descargandoPdf={descargandoPdf}
            />
            <CapacitacionDetalle data={data} fotos={fotos} onEditAsistentes={() => history.push(editPath)}>
              <ImagenesDetalleSection
                imagenes={data.imagenes}
                subtitle="Evidencia fotográfica de la capacitación."
                alt="Evidencia de la capacitación"
                api={detalle}
              />
            </CapacitacionDetalle>
          </>
        )}
      </div>
    </BlockUi>
  );
};

export default CapacitacionDetallePage;
